module.exports = __webpack_public_path__ + "static/media/Light Gold.813dc325.jpg";